export const isMobile = () => window.screen.width < 481;
